import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import styled from '@emotion/styled';

const PrimaryControlsWrapper = styled('div')(
  {
    marginRight: 'auto',
    display: 'inline-flex',
    alignItems: 'center',
    width: 'calc(100% - 60px)',
    span: {
      marginRight: 6,
      fontWeight: 500,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  addHighContrastStyles(({ theme }) => ({
    '>span': {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.background.paper,
    },
  })),
);

export default PrimaryControlsWrapper;
